export function treeDataRemoveEmptyChilds (node) {
  node.forEach(item => {
      if ('childs' in item && item.childs.length === 0) {
          delete item.childs
      } else if ('childs' in item && item.childs.length) {
          treeDataRemoveEmptyChilds(item.childs)
      }
  })
  return node
}